export const UsFlag = (props) => (
  <svg viewBox="0 0 38 20" aria-hidden="true" {...props}>
    <rect width="38" height="20" fill="#fff" />
    {[0, 2, 4, 6, 8, 10, 12].map((i) => (
      <rect key={i} y={(i * 20) / 13} width="38" height={20 / 13} fill="#B22234" />
    ))}
    <rect width="15.2" height={(7 * 20) / 13} fill="#3C3B6E" />
  </svg>
);

export const PlFlag = (props) => (
  <svg viewBox="0 0 16 10" aria-hidden="true" {...props}>
    <rect width="16" height="5" fill="#fff" />
    <rect y="5" width="16" height="5" fill="#DC143C" />
  </svg>
);
